import { type BasicContentObjectRedux, type ReduxUser } from 'models';
import { useState } from 'react';
import { Button, Modal, ShareIcon } from 'ui';
import { ShareContentObject } from './ShareContentObject';

type P = {
  item: BasicContentObjectRedux;
  viewer: ReduxUser;
};

const ShareButton = ({ item, viewer }: P) => {
  const [isShareOpen, setIsShareOpen] = useState<boolean>(false);

  return (
    <div className="share-button">
      <Button
        item={{
          type: 'text',
          icon: <ShareIcon className="share-button__icon" />,
          className: 'share-button__button',
          onClick: () => setIsShareOpen(true),
        }}
      >
        Share
      </Button>
      <Modal footer={false} isOpened={isShareOpen} onCancel={() => setIsShareOpen(false)} title="Sharing Post">
        <ShareContentObject item={item} viewer={viewer} onClose={() => setIsShareOpen(false)} />
      </Modal>
    </div>
  );
};

export default ShareButton;
